import { APP_CONFIG } from '../../../../app.config';
import { EntityType } from '../../../../shared/enums/entity-type.enum';

export class PaymentStatementResponse {
  totalPages: number;
  totalRecords: number;
  data: PaymentStatement[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class PaymentStatement {
  id: number;
  amount: number;
  fee: number;
  status: string;
  type: string;
  createdAt: string;
  movementObject: PaymentStatementMovementObject;
  paymentType: string;

  //aux view
  description: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    let paymentMethod: string;
    if (this.movementObject) {
      paymentMethod = this.movementObject.paymentMethod;
      switch (this.type) {
        case 'TRANSFER':
          this.description = this.getTransferDescription();
          break;
        case 'FEE_COLLECTION':
          this.description = 'Serviços de gateway';
          break;
        default:
          this.description = this.getTypeDescription(this.movementObject.type);
          if (!this.description) {
            this.description = paymentMethod
              ? this.getPaymentMethodDescription(paymentMethod)
              : '-';
            if (this.movementObject.anticipationFee) {
              this.description = `${this.description} (antecipação)`;
            }
          }
          break;
      }
    } else {
      this.description = this.getTypeDescription(this.type);
      paymentMethod = this.paymentType;
    }
    if (paymentMethod && paymentMethod.toUpperCase() == 'CREDIT_CARD') {
      if (this.amount < 0) {
        this.amount -= APP_CONFIG.FEES.CREDIT_CARD_FIXED_FEE;
        this.fee -= APP_CONFIG.FEES.CREDIT_CARD_FIXED_FEE;
      } else {
        this.amount += APP_CONFIG.FEES.CREDIT_CARD_FIXED_FEE;
        this.fee += APP_CONFIG.FEES.CREDIT_CARD_FIXED_FEE;
      }
      if (!this.description) {
        this.description = 'Cartão de Crédito';
      }
    }
  }

  private getTransferDescription(): string {
    let transferTypeDescription: string = '';
    switch (this.movementObject.type.toUpperCase()) {
      case 'INTER_RECIPIENT':
        transferTypeDescription = 'entre Contas';
        break;
      default:
        transferTypeDescription = this.movementObject.type.toUpperCase();
        break;
    }
    if (this.amount > 0) {
      return this.movementObject.status.toUpperCase() == 'FAILED'
        ? 'Estorno por falha na transferência'
        : 'Transferência ' + transferTypeDescription;
    } else {
      return 'Transferência ' + transferTypeDescription;
    }
  }

  private getTypeDescription(type: string): string {
    if (type) {
      switch (type.toUpperCase()) {
        case 'CHARGEBACK':
          return 'Disputa';
        case 'REFUND':
          return 'Estorno';
        case 'CHARGEBACK_REFUND':
          return 'Estorno da disputa';
        default:
          return '';
      }
    }
    return '';
  }

  private getPaymentMethodDescription(type: string): string {
    if (type) {
      switch (type.toUpperCase()) {
        case 'CREDIT_CARD':
          return 'Cartão de crédito';
        case 'DEBIT_CARD':
          return 'Cartão de débito';
        default:
          return type.toUpperCase();
      }
    }
    return '';
  }
}

export class PaymentAccountFilter {
  entity: EntityType;
  entityId: number;
  startDate: string;
  endDate: string;
  page: number;
  size: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export interface PaymentStatementMovementObject {
  fee: number;
  object: string; //"transfer", "payable"
  id: string;
  status: string; //"failed", "paid"
  amount: number; //in cents
  createdAt: string;
  type: string; //"ted", "credit"
  anticipationFee: number;
  fraudCoverageFee: number;
  recipientId: string;
  paymentMethod: string; //"pix";
  gatewayId: string;
}



// WEBPACK FOOTER //
// ./src/app/pages/receivables/payment-account/models/payment-statement.model.ts